 interface String {
    sanitize(): string;
  }
  
  String.prototype.sanitize = function (): string {
    return this?.replace(/[^0-9a-zA-Z]/g, "_") 
  }